'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _components = require('../../components');

var _IyvListTutorial = require('./IyvListTutorial.css');

var _IyvListTutorial2 = _interopRequireDefault(_IyvListTutorial);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListTutorialRestartButton = (_dec = (0, _reactCssModules2.default)(_IyvListTutorial2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListTutorialRestartButton, _Component);

  //
  function IyvListTutorialRestartButton(props) {
    (0, _classCallCheck3.default)(this, IyvListTutorialRestartButton);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListTutorialRestartButton.__proto__ || (0, _getPrototypeOf2.default)(IyvListTutorialRestartButton)).call(this, props));
  }
  //

  (0, _createClass3.default)(IyvListTutorialRestartButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'button',
        {
          styleName: 'tutorial-wrap-restart',
          onClick: this.props.clickTutorialRestart,
          role: 'button',
          tabIndex: '0'
        },
        _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nospace: true }),
        '\xA0 Show me how this works'
      );
    }
  }]);
  return IyvListTutorialRestartButton;
}(_react.Component), _class2.propTypes = {
  clickTutorialRestart: _react.PropTypes.func
}, _temp)) || _class);
exports.default = IyvListTutorialRestartButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListTutorial/IyvListTutorialRestartButton.js
// module id = 1388
// module chunks = 0